import { render, staticRenderFns } from "./BaseFooterDeal.vue?vue&type=template&id=676d1ab2&"
import script from "./BaseFooterDeal.vue?vue&type=script&lang=js&"
export * from "./BaseFooterDeal.vue?vue&type=script&lang=js&"
import style0 from "./BaseFooterDeal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports